import { ModalDescription } from '@src/common/components/modal/ModalDescription';
import { useTranslation } from 'react-i18next';

export const ModalPermitDescription = (props: {
  jurisdiction: string;
  type: string;
  stateField: string;
}) => {
  const { t } = useTranslation();

  return (
    <ModalDescription
      labelsToValue={[
        {
          label: t('permitApplication.description.jurisdiction'),
          value: props.jurisdiction,
        },
        {
          label: t('permitApplication.description.permitType'),
          value: props.type,
        },
        {
          label: t('permitApplication.description.stateId'),
          value: props.stateField,
        },
      ]}
    />
  );
};
